const SITE_URL = 'https://herbirthkeeper.co.uk'
const SITE_NAME = 'H.E.R Birth Keeper'
const DEFAULT_TITLE = `${SITE_NAME} | Antenatal & Postpartum Birth Keeper — Essex, North Kent & East London`
const DEFAULT_DESCRIPTION =
  'A safe, nurturing space created to gently support you through pregnancy, birth, and postpartum. Personalised, holistic birth keeper services across Essex, North Kent and East London.'

export const SEO = {
  siteUrl: SITE_URL,
  siteName: SITE_NAME,
  defaultTitle: DEFAULT_TITLE,
  defaultDescription: DEFAULT_DESCRIPTION,
  pages: {
    home: {
      title: DEFAULT_TITLE,
      description: DEFAULT_DESCRIPTION,
    },
    about: {
      title: `About Simone | ${SITE_NAME}`,
      description:
        'Meet Simone, founder of H.E.R Birth Keeper. With over 15 years in the VAWG sector and her own lived experience as a Black mother, Simone provides culturally aware, trauma-informed birth keeper support.',
    },
    services: {
      title: `Services | ${SITE_NAME}`,
      description:
        'Explore tailored birth keeper services: Antenatal Empowerment Experience, Birth Healing Debrief Sessions, Postpartum Home Visits, and the full H.E.R Birth Journey Experience.',
    },
    enquiry: {
      title: `Book a Free Support Call | ${SITE_NAME}`,
      description:
        'Unlock your free support call with Simone. Share a few details about your journey and she will be in touch to help you find the right support — no commitment, completely confidential.',
    },
    notFound: {
      title: `Page Not Found | ${SITE_NAME}`,
      description: DEFAULT_DESCRIPTION,
    },
  },
} as const
